<template>
    <button
        type="button"
        :class="{ 'favorite': value, 'is-big': isBig }"
        aria-label="favorite"
        class="favorite-heart"
        @click="favoriteProduct"
    >
        <font-awesome-icon
            icon="heart"
            class="floating-heart"
        />
        <span class="favorite-trigger">
            <font-awesome-icon
                icon="heart"
                class="heart filled"
            />
            <font-awesome-icon
                :icon="['fal', 'heart']"
                class="heart line"
            />
        </span>
    </button>
</template>

<script>
    export default {
        props: {
            productId: {
                type: Number,
                required: true,
            },
            initialValue: {
                type: Boolean,
                required: true,
            },
            isBig: {
                type: Boolean,
                default: false,
            },

        },

        data() {
            return {
                value: this.initialValue,
            };
        },

        methods: {
            async favoriteProduct() {
                if (! window.App.userId) {
                    this.$modal.show('create-account', { openedFromFavoriteHeart: true });
                    return;
                }

                try {
                    const response = await axios.post(route('front.api.products.favorite', this.productId));
                    this.value = response.data.isProductFavorite;
                } catch (error) {
                    if (error.response && error.response.status === 401) {
                        this.$modal.show('login');
                        return;
                    }

                    throw error;
                }
            },
        },
    };
</script>
